import { createContext, useContext } from 'react';

export const WaveContext = createContext();

export const useWavesFilterContext = () => useContext(WaveContext);
